export default {
  all: {
    acceptChat: 'Прийняти чат',
    accountStatus: 'Статус',
    action: 'Дії',
    activate: 'Активувати',
    activated: 'Активовано',
    active: 'Активний',
    addBulkMessaging: 'Додати розсилку',
    addFirstItem: 'Додати {{itemType}}',
    addChatWidget: 'Додати Чат Віджет',
    addCustomer: 'Додати клієнта',
    addingChatWidget: 'Створення Чат Віджету',
    addDepartment: 'Додати Відділ',
    addMembers: 'Додати Співробітників',
    addNew: 'Додати нове',
    addTag: 'Додати теґ:',
    addTemplates: 'Додати новий шаблон',
    addingDepartment: 'Створення відділу',
    administrators: 'Повідомити адміністраторів',
    all_channels_instant: 'Правила для месенджерів та Live Chat',
    allChannels: 'Усі канали',
    allCustomers: 'Усі клієнти',
    allMembers: 'Усі співробітники',
    allPlans: 'Усі плани',
    allTags: 'Усі теґи',
    amount: 'Сума',
    annually: 'Щорічно',
    approved: 'Схвалено',
    attachment: 'Вкладення',
    'auto-messages': 'Автоповідомлення',
    availablePlans: 'Доступні плани',
    available: 'Доступно {{item}}: {{count}}',
    chat_duration: 'Середня Тривалість',
    averageRating: 'Середній Рейтинг',
    averageReaction: 'Середня Реакція',
    response_time: 'Середня Відповідь',
    bankAccountDetails: 'Банківські реквізити',
    bankName: 'Назва банку',
    bankCountry: 'Країна банку',
    billedAnnually: 'Сплата щорічно',
    billedMonthly: 'Сплата щомісяця',
    botPlaceholder: 'Введіть токен вашого бота',
    botHint: 'Спочатку введіть токен',
    botActivated: 'підключено',
    botPaused: 'призупинено',
    bulkErrors: 'Гості, що не отримали повідомлення ({{messagesCount}}):',
    bulkMessage: 'Розсилка',
    bulkMessagePlaceholder: 'Введіть повідомлення, яке потрібно надіслати',
    bulkSuccess: 'Успішно надіслано: {{messagesCount}}.',
    is_branding: 'Без брендингу Skibble',
    is_custom: 'Кастомний план',
    browser: 'Браузер',
    browserLanguage: 'Мова браузера',
    buttonPlacement: 'Розміщення кнопки',
    plan_business: 'Бізнес',
    callback: 'Передзвоніть мені',
    callbackActivated: 'Зворотний дзвінок активовано',
    callbackButton: 'Кнопка Передзвоніть мені',
    callbackExplain: 'Залучайте більше відвідувачів веб-сайту, пропонуючи миттєвий зворотний дзвінок.',
    callbackPaused: 'Зворотний дзвінок призупинено',
    callbackRequest: 'Запит на зворотній дзвінок',
    callbackTip: 'Це буде окрема кнопка на веб-сайті.',
    cameFrom: 'Прийшов з',
    cancel: 'Скасувати',
    cancelled: 'Скасований',
    cancelSubscription: 'Скасувати підписку',
    channel: 'Канал',
    channelConfig: 'Конфігурація каналів',
    channels: 'Канали',
    channelsC: 'Каналів',
    'chat-customization': 'Кастомізація чат віджета ',
    chats: 'Чати',
    chat_owner: 'Повідомити власника чату',
    changeEmail: 'Змінення електронної адреси',
    cherry: 'Вишневий',
    classic: 'Класичний',
    clickToConfirm: 'Натисніть, щоб підтвердити',
    clientFilters: 'Клієнтські фільтри',
    clientCountTip: 'Отримувачів повідомлення: {{count}}',
    close: 'Закрити',
    closeChat: 'Закрити чат',
    closed: 'Закриті',
    closedBy: 'Закрито',
    closedByGuest: 'Закрито гостем',
    comment: 'Коментар',
    companyEmail: 'Email компанії',
    companyInformation: 'Інформація про компанію',
    companyInfoTip: 'Заповніть базові контактні дані і галузь вашого бізнесу',
    companyInfoDescription: 'Чим займається ваша компанія?',
    companyName: "Ім'я компанії",
    companyPhone: 'Телефон компанії',
    companyWebsite: 'Вебсайт компанії',
    complete: 'Завершено',
    complete_with_error: 'Завершено з помилкою',
    connect: 'Підключити',
    contactDetails: 'Деталі контакту',
    contactInfo: 'Контактна інформація',
    copyCode: 'Скопіювати код',
    coral: 'Кораловий',
    corporate: 'Корпоративний',
    count: 'К-сть',
    create: 'Створити',
    created: 'Створено',
    createdAt: 'Створено',
    currentPassword: 'Поточний пароль',
    currentPlan: 'Поточний план',
    customer_administrator: 'Адміністратор',
    customer_owner: 'Власник',
    customers: 'Клієнти',
    customerInfo: 'Інформація клієнта',
    customization: 'Кастомізація',
    is_customization: 'Кастомізація',
    date: 'Дата',
    daysLeft: 'Днів залишилося',
    deactivate: 'Деактивувати',
    deactivateAccount: 'Видалити ваш акаунт',
    declined: 'Відхилено',
    delay: 'Затримка (секунди)',
    delayMS: 'Затримка (мм:сс)',
    delete: 'Видалити',
    deleteDepartment: 'Видалити відділ',
    deleteMemberPermanently: 'Видалити співробітника',
    departmentName: 'Назва відділу',
    departments: 'Відділи',
    departmentsField: 'Відділи ({{choosedDep}} з {{allDeps}})',
    description: 'Опис',
    desktop: 'Десктоп',
    details: 'Подробиці',
    device: 'Пристрій',
    EDRPOU: 'ЄДРПОУ',
    disabledCardTip: 'Спочатку включіть тригер для першого повідомлення',
    draft: 'Чернетка',
    editTemplate: 'Відредагуйте свій шаблон',
    email: 'Email',
    emailNotifications: 'Сповіщення електронною поштою',
    enterChatWidgetName: 'Введіть назву чат віджета',
    enterYourMessage: 'Введіть ваше повідомлення',
    enterYourPassword: 'Введіть свій пароль',
    exp: 'до',
    expired: 'Закінчився',
    expires: 'Закінчується',
    extend: 'Подовжити',
    facebookMessenger: 'facebook messenger',
    field: 'Поле',
    fieldsTooltip: 'Заповніть усі поля у картці',
    firstLastName: "Ім'я та прізвище",
    first_message: 'Перше повідомлення',
    firstMessageTip: 'Повідомлення запускається із затримкою після завантаження віджета на сторінку.',
    messageTipIdleOperator:
      'Повідомлення запускається, якщо оператор не відповів на гостьове повідомлення протягом зазначеного часу.',
    firstMessageTipLivechat: 'Повідомлення запускається відразу після того, як клієнт починає чат.',
    firstSeen: 'Перший візит',
    for: 'для',
    forms: 'Форми',
    forward: 'Направити',
    forwardTo: 'Направити до ',
    forwardedTo: 'Передано {{departmentOrOperatorName}} від {{operatorName}}',
    free: 'Безкоштовно',
    plan_free: 'Безкоштовний план',
    planTitle: 'Назва плану',
    friday: "П'ятниця",
    fullName: "Повне ім'я",
    general: 'Загальні',
    generateInvoice: 'Згенерувати рахунок',
    gold: 'Золотий',
    grass: 'Трав’яний',
    guest: 'Гість',
    guestInfo: 'Інформація гостя',
    guestOfflinePlaceholder: 'Гість зараз не на сайті, він побачить ваші повідомлення, коли повернеться',
    guestOfflineText: 'Гість покинув вебсайт',
    hideBranding: 'Приховати брендинг',
    h: 'г',
    hoursOfWorkTitle: 'Встановіть робочі години вашої команди',
    hoursOfWorkTip:
      "Робочі години впливають на доступ Гостей до каналів зв'язку у чат віджеті та кнопки зворотного дзвінка",
    iconType: 'Тип іконки',
    inactive: 'Неактивний',
    inactiveWidgetTip: 'Чат Віджет не відображається на вебсайті, і ви перестаєте отримувати повідомлення',
    industry: 'Галузь',
    idle_guest: 'Очікування гостя',
    idle_operator_new_chat: 'Очікування оператора в новому чаті',
    idle_operator_open_chat: 'Очікування оператора у відкритому чаті',
    information: 'Інформація',
    in_progress: 'Виконується',
    inProcessing: 'Обробляється',
    installed: 'Встановлено',
    installedNot: 'Не встановлено',
    interfaceLanguage: 'Мова інтерфейсу',
    invitationsSent: 'Запрошення надіслано',
    invite: 'Запросити',
    inviteMember: 'Запрошення співробітника',
    joinedChat: 'долучено до чату',
    languages: 'Мови',
    languagesExplain:
      'Мова системи використовується лише для інтерфейсу. Операційні мови - ті якими ви можете комунікувати',
    lastMessage: 'Останнє повідомлення',
    lastMonth: 'Попередній місяць',
    lastSeen: 'Останній візит',
    lastWeek: 'Попередній тиждень',
    lastYear: 'Попередній рік',
    last30days: 'Останні 30 днів',
    last90days: 'Останні 90 днів',
    leaveNumberToCallback: 'Будь ласка, залиште свій номер, і ми вам передзвонимо!',
    left: 'Зліва',
    link: 'Посилання',
    liveChatExplain: 'Live chat стане доступним після імплементації коду чат віджета на вашому вебсайті',
    liveChatHint: 'Спочатку імплементуйте код на вашому вебсайті',
    liveChatActivated: 'Live chat активовано',
    live_chat_delayed: 'Правила для LiveChat (із затримкою)',
    liveChatPaused: 'Live chat призупинено',
    loginAsOwner: 'Увійти як власник',
    memberInfo: 'Інформація про співробітника',
    memberMessengers: 'Месенджери співробітника',
    members: 'Співробітники',
    messagingChannels: "Канали Зв'язку",
    message: 'Повідомлення',
    messageText: 'Текст повідомлення',
    messengers: 'Месенджери',
    metaHint: 'Спочатку треба підключити',
    metaActivated: 'підключено',
    metaPaused: 'призупинено',
    min: 'хв',
    mobile: 'Смартфон',
    monday: 'Понеділок',
    monthly: 'Щомісяця',
    // mostPopulartags: 'Найпопулярніші теґи',
    // mostPopularbrowser: 'Найпопулярніші вебпереглядачі',
    // mostPopularbrowser_lang: 'Найпопулярніші мови вебпереглядача',
    // mostPopulardevice: 'Найпопулярніші пристрої',
    // mostPopulardevice_os: 'Найпопулярніші операційні системи',
    // mostPopulartimezone: 'Найпопулярніші часові пояси',
    mostPopulartags: 'Теґи',
    mostPopularbrowser: 'Вебпереглядачі',
    mostPopularbrowser_lang: 'Мови вебпереглядача',
    mostPopulardevice: 'Пристрої',
    mostPopulardevice_os: 'Операційні системи',
    mostPopulartimezone: 'Часові пояси',
    name: "Ім'я",
    new: 'Нові',
    newBulkMessage: 'Нова розсилка',
    new_chat_working_hours: 'Новий чат (робочі часи)',
    new_chat_working_hours_tip: 'Укажіть затримку, після якої буде надіслано електронний лист із сповіщенням',
    new_chat_non_working_hours: 'Новий чат (неробочі часи)',
    new_chat_non_working_hours_tip:
      'Вкажіть, кого потрібно повідомити про повідомлення клієнта в неробочий час',
    newPassword: 'новий пароль',
    nextPayment: 'Наступний платіж',
    noAvailableChannels:
      'Більше немає доступних каналів. Щоб отримати більше каналів, змініть план або вимкніть інший канал.',
    non_working_hours: 'Неробочі години',
    no_response: 'Немає відповіді в активному чаті',
    no_response_tip: 'Укажіть затримку, після якої буде надіслано електронний лист із сповіщенням',
    notConnected: 'Не підключено',
    nothingFound: 'Нічого не знайдено',
    notificationsTitle: 'Звукові сповіщення',
    notificationTitle1: 'Сповіщати мене, коли я отримую новий чат',
    notificationExplain1: 'Ви отримуватимете сповіщення про кожен новий або переданий чат',
    notificationTitle2: 'Сповіщати мене про нові повідомлення',
    notificationExplain2: 'Ви отримуватимете сповіщення про кожне нове повідомлення у відкритих чатах',
    notificationsTitle3: 'Push-сповіщення',
    of: 'з',
    onlyPreviewTipWidget:
      'Це лише попередній перегляд! Ваш віджет неактивний, оскільки у вас немає активних каналів.',
    onlyPreviewTipCallback:
      'Це лише попередній перегляд! Кнопка «Зворотний дзвінок» неактивна, для її використання потрібно спочатку активувати цей канал.',
    open: 'Відкриті',
    operationalLanguages: 'Операційні мови',
    operator: 'Оператор',
    operators: 'Повідомити всіх операторів',
    options: 'Опції',
    orange: 'Помаранчевий',
    orderReference: 'Номер замовлення',
    other: 'Інші',
    owner: 'Власник',
    pageNotFound: 'Сторінку не знайдено',
    password: 'пароль',
    passwordSecurity: 'Змінення пароля',
    paymentMethod: 'Спосіб оплати',
    paymentsRequisites: 'Платіжні реквізити',
    paymentType: 'Тип платежу',
    pending: 'Очікування',
    personal: 'Особисті',
    personalInformation: 'Особиста інформація',
    personalTemplate: 'Особистий шаблон',
    phone: 'Телефон',
    plan: 'План',
    planEnds: 'Дата закінчення',
    preChat: 'Контактна форма',
    pricing: 'Ціна',
    privacyPolicy: 'Політика конфіденційності',
    privacyPolicyAgreeText:
      'Я погоджуюся, що мої персональні дані, надані через чат, будуть оброблені з метою отримання онлайн',
    privacyPolicyLinkText: 'підтримки та консультації.',
    profile: 'Мій Профіль',
    profileImageTip: 'Завантажте свою світлину, рекомендований розмір зображення 512x512px',
    profilePicture: 'Зображення профілю',
    profilePictureTip: 'Завантажуйте реальне зображення, це підвищує рівень довіри ваших клієнтів.',
    rated: 'Оцінено на',
    rating: 'Рейтинг',
    ratingWrite: 'Як ви оцінюєте нашу роботу?',
    repeatPassword: 'Повторіть пароль',
    resendInvitation: 'Надіслати повторно',
    region: 'Регіон',
    reset: 'Скинути',
    resetPassword: 'Скинути пароль',
    restoreSubscription: 'Відновити підписку',
    results: 'Результати',
    retypePassword: 'введіть пароль повторно',
    required: "Обов'язкове",
    right: 'Справа',
    role: 'Роль',
    saturday: 'Субота',
    save: 'Зберегти',
    saveUp: 'Заощаджуйте до 20%',
    saveSchedule: 'Зберегти розклад',
    schedule: 'Запланувати',
    scheduled: 'Заплановано',
    sendMessagesNow: 'Відправити зараз',
    search: 'Пошук',
    sec: 'с',
    selectDate: 'Фільтрувати за датою',
    send: 'Надіслати',
    sendInvitation: 'Надіслати запрошення',
    settings: 'Налаштування',
    setup: 'Встановлення',
    setupCodeText:
      'Додайте код на кожну сторінку вашого сайту, на якій ви хочете показувати віджет. Код треба розмістити перед тегом </body> вашого коду html.',
    plan_small_team: 'Дрібна команда',
    planCharacteristics: 'Характеристики плану',
    prices: 'Ціни',
    priceAnnually: 'Ціна за рік',
    priceMonthly: 'Ціна за місяць',
    second_message: 'Друге повідомлення',
    secondMessageTip: 'Повідомлення запускається після затримки після першого повідомлення.',
    messageTipIdleGuest:
      'Повідомлення запускається, якщо гість не відповів на повідомлення оператора протягом зазначеного часу.',
    secondMessageTipLivechat: 'Друге повідомлення буде надіслано одразу після першого.',
    specified_emails: 'Повідомити конкретні електронні адреси',
    status: 'Статус',
    sum: 'Сума',
    sunday: 'Неділя',
    is_support: 'Пріоритетна Онлайн Підтримка',
    switchToPlan: 'Перейти на план',
    system: 'Система',
    system_administrator: 'Адміністратор Платформи',
    systemLanguage: 'Мова системи',
    tablet: 'Планшет',
    tags: 'Теґи',
    templateCheckboxLabel: 'Загальний шаблон (дозволяє його використовувати всім співробітникам)',
    templateName: 'Назва шаблону',
    template: 'Шаблон',
    templates: 'Шаблони',
    templatesC: 'Шаблонів',
    thisMonth: 'Поточний місяць',
    thisWeek: ' Поточний тиждень',
    thisYear: 'Поточний рік',
    thursday: 'Четвер',
    time: 'Час',
    TIN: 'ІПН',
    title: 'Назва',
    timeZone: 'Часовий пояс',
    to: 'до',
    toAddNewLine: 'щоб додати новий рядок',
    today: 'Сьогодні',
    total: 'Разом',
    translations: 'Переклади',
    trial: 'Пробний',
    trialPeriod: '14-денний пробний період ',
    tuesday: 'Вівторок',
    turquoise: 'Бірюзовий',
    type: 'Тип',
    unlimitTemplates: 'Необмежені Шаблони',
    updatePlan: 'Оновити план',
    upgradeYourPlanToAdd: 'Оновіть свій план, щоб додати більше',
    upgradeYourPlanToUse: 'Оновіть свій план, щоб використовувати цю функцію',
    upload: 'Завантажити',
    uploadAndImage: 'Завантажити файл',
    user: 'Користувач',
    users: 'Користувачів',
    usersIncluded: 'Користувачів включено',
    violet: 'Бузковий',
    visible: 'Видиме',
    website: 'Вебсайт',
    wednesday: 'Середа',
    widget: 'Віджет',
    widgets: 'Чат Віджетів',
    widgetAppearance: 'Зовнішній вигляд віджета',
    widgetButton: 'Кнопка віджета',
    widgetColor: 'Колір віджета',
    withSchedule: 'Надіслати повідомлення в певну дату та час',
    writeYourMessageHere: 'Напишіть своє повідомлення тут',
    yourCompanyName: 'Назва вашої компанії',
    yourCurrentPlan: 'Ваш поточний план',
    '@username': '@username',
    ecommerce: 'Електронна комерція',
    logistics: 'Логістика',
    finance: 'Фінанси',
    education: 'Освіта',
    travel: 'Подорожі',
    real_estate: 'Нерухомість',
    construction: 'Будівництво',
    it: 'Інформаційні технології',
    medical: 'Медицина',
    poweredBy: 'Powered by',
    quickWayToContact: 'Ось швидкий спосіб зв’язатися з нами!',
    sendMessageToStart: 'Надішліть повідомлення, щоб почати розмову',
    sendUsMessage: 'Надішліть нам повідомлення',
    submit: 'Підтвердити',
    welcome: 'Ласкаво просимо',
    writeIn: 'Написати в',
    yesterday: 'Вчора',
    yourSubscriptionEnds: 'Ваша підписка скоро закінчиться',
  },
  auth: {
    alreadyHaveAccount: 'Вже є акаунт?',
    backTo: 'Повернутися до',
    cancel: 'Скасувати',
    changePassword: 'Змінити пароль',
    checkYourMailbox: 'Перевірте свою поштову скриньку',
    clientInformation: 'Інформація клієнта',
    confirmYourEmail: 'Підтвердьте свою електронну адресу',
    continueGoogle: 'Продовжити з Google',
    createYourAccount: 'Створіть акаунт',
    dontHaveAccount: 'Немає акаунта?',
    firstPageText: 'Усе необхідне для ефективної бізнес комунікації',
    firstPageText1:
      'Власники бізнесу знають, що загублені повідомлення та зниклі історії переписок можуть завдати суттєвих збитків та призвести до втрати клієнтів.\nSkibble розроблений, щоб вирішувати ці питання.',
    footerText: 'Усі Права Застережено',
    forgotPassword: 'забули свій пароль?',
    language: 'Мова',
    legalPagesInscription: 'Натискаючи «Зареєструватися», ви підтверджуєте, що прочитали',
    legalPagesInscription1: ', переглянули та погодилися з',
    newPassword: 'Новий пароль',
    or: 'або',
    passRecoverSentText:
      'Ми надіслали вам інструкції щодо відновлення пароля. Також перевірте теку зі спамом, якщо ви не можете знайти наш лист!',
    passRecoverText: 'Введіть свою електронну адресу нижче, щоб отримати інструкції щодо зміни пароля.',
    passwordRecovery: 'Відновлення пароля',
    privacyPolicy: 'Положення про конфіденційність та захист персональних даних',
    proceed: 'Продовжити',
    recoverPassword: 'Відновити пароль',
    rememberPassword: "Запам'ятати пароль",
    requestText:
      'Щоб використовувати Skibble, спершу підтвердьте свою електронну адресу. Ми надіслали посилання на',
    requestText1: '. Перевірте папку зі спамом, якщо лист не приходить.',
    signIn: 'Увійти',
    signUp: 'Зареєструватися',
    termsAndConditions: 'Правила та умови надання послуг',
    toSignIn: 'Авторизації',
    welcome: 'Ласкаво просимо!',
    withTermsAndConditions: 'Правилами та умовами надання послуг',
  },
  emptyPages: {
    bulkMessagingHeader: 'Масових розсилок ще немає',
    bulkMessagingText: 'Створіть вашу першу розсилку.',
    contactsHeader: 'Контактів ще немає',
    contactsText: "Контакт з'явиться тут, коли Гість зверненться до вас.",
    chatsHeader: 'Чатів ще немає',
    chatsText: "Чат з'являється, коли Гість звертається до вас.",
    chatsSelectedHeader: 'Чат не вибрано',
    chatsSelectedText: 'Виберіть Чат в лівій боковій панелі.',
    customersHeader: 'Клієнтів ще немає',
    customersText: "Клієнт з'явиться тут, коли Власник зареєструє компанію.",
    deleteAccountHeader: 'Видалити акаунт',
    deleteAccountText:
      'Якщо ваш обліковий запис вам більше не потрібен, ви можете видалити його, але майте на увазі, що видалення облікового запису є остаточним. Не буде можливості відновити обліковий запис.',
    departmentsHeader: 'Відділів ще немає',
    departmentsText:
      'Додайте Відділ, щоб розділити Операторів на групи. Це дозволяє направити Чати до конкретної групи фахівців.',
    knowledgeBaseHeader: 'База знань пуста',
    knowledgeBaseText: 'Спочатку додайте категорію або статтю',
    paymentsHeader: 'Оплат ще немає',
    paymentsText: 'Платіж з’явиться тут після того, як Гість оплатить план.',
    teamChatNoMessageHeader: 'Тут ще немає повідомлень',
    teamChatNoMessageText: '',
    teamChatsSelectedHeader: 'Будь ласка, виберіть контакт, щоб почати розмову',
    teamChatsSelectedText: '',
    templatesHeader: 'Шаблонів ще немає',
    templatesText: 'Створіть шаблон повідомлення для швидкої відповіді.',
    templateSelectedHeader: 'Шаблон не вибрано',
    templateSelectedText: 'Виберіть Шаблон в лівій боковій панелі.',
    widgetsHeader: 'Чат Віджетів ще немає',
    widgetsText: 'Додайте Віджет, щоб ваші Гості мали змогу надсилати і отримувати повідомлення.',
    invoicesHeader: 'Інвойсів ще немає',
    invoicesText: '',
  },
  menu: {
    accountSettings: 'Налаштування акаунта',
    bulkMessaging: 'Масова розсилка',
    chats: 'Чати',
    contacts: 'Контакти',
    customers: 'Клієнти',
    dashboard: 'Дашборд',
    deleteAccount: 'Видалити акаунт',
    deleteCompany: 'Видалити компанію',
    departments: 'Відділи',
    general: 'Загальні',
    helpCenter: 'Центр допомоги',
    hoursOfWork: 'Робочі години',
    invoices: 'Інвойси',
    knowledgeBase: 'База знань',
    members: 'Співробітники',
    myCompany: 'Моя компанія',
    notifications: 'Сповіщення',
    payments: 'Платежі',
    profile: 'Мій профіль',
    settings: 'Налаштування',
    signOut: 'Вихід',
    subscription: 'Підписка',
    subscriptionPlans: 'Плани підписок',
    teamChat: 'Командний чат',
    templates: 'Шаблони',
    widgets: 'Чат Віджети',
  },
  meta: {
    appDescription:
      'Рішення для бізнесу, що автоматизує та покращує процес спілкування з клієнтами. Чат-боти, месенджери, live chat на сайт, та багато іншого.',
    appTitle: 'Месенджери та онлайн чати для бізнесу | Skibble',
    bulkMessagingTitle: 'Skibble | Масова розсилка',
    chatsTitle: 'Skibble | Чати',
    companyTitle: 'Skibble | Моя компанія',
    contactsTitle: 'Skibble | Контакти',
    customersTitle: 'Skibble | Клієнти',
    dashboardTitle: 'Skibble | Дашборд',
    knowledgeBaseTitle: 'Skibble | База знань',
    membersTitle: 'Skibble | Співробітники',
    settingsTitle: 'Skibble | Налаштування акаунту',
    signTitle: "Skibble об'єднує!",
    subscriptionPlansTitle: 'Skibble | Плани підпискок',
    templatesTitle: 'Skibble | Шаблони',
  },
  popupAlerts: {
    'Department already exists': 'Відділ вже існує',
    'Department is in use': 'Відділ використовується',
    'Wrong email or password.': 'Неправильна пошта або пароль',
    codeCopied: 'Код скопійовано',
    dataSuccessfullySaved: 'Дані успішно збережені',
    emailConfirmed: 'Пошту підтверджено',
    dataCopied: 'Дані скопійовано!',
    file: 'Файл',
    'file-too-large': '{{fileName}}\nРозмір перевищує 20 МБ',
    image: 'Зображення',
    invitationLinkCopied: 'Посилання на запрошення скопійовано!',
    invitationSent: 'Запрошення надіслано',
    newMessage: 'Нове повідомлення',
    newChat: 'Новий чат',
    max_subscription_limit_reached: 'Досягнуто ліміту підписки: неможливо зберегти',
    'Member already exists': 'Співробітник вже існує',
    "Member is owner of company and can't be deleted":
      'Співробітник є власником компанії і не може бути видалений',
    'Member not found': 'Такого користувача не існує',
    noActiveChannelsText: 'У вас немає активних каналів і ви не можете отримувати нові чати. ',
    noActiveChannelsLink: 'НАЛАШТУВАТИ',
    only10Files: 'Не більше 10 файлів у повідомленні',
    passRecoverySentCustomers: 'Інструкції для зміни паролю надіслано на пошту {{email}}',
    somethingWentWrong: 'Щось пішло не так',
    'The user does not exist.': 'Такого користувача не існує',
    wrongPass: 'Неправильний пароль',
    yourSubscriptionEnds: 'Ваша підписка скоро закінчиться!',
  },
  validation: {
    capital: 'Велика літера',
    checkboxError: 'Оберіть хоча б один варіант',
    email: 'Некорректна електронна адреса',
    enterAllChars: 'Введіть усі символи',
    lowercase: 'Мала літера',
    emailsError: 'Оберіть хоча б один email',
    minLength: '8 Символів',
    number: 'Цифра',
    onlyDigits: 'Тільки цифри',
    passEqualTo: 'Паролі не збігаються',
    password: 'Ваш пароль не відповідає вимогам',
    phone: 'Формат недійсний, будь ласка, введіть номер, який починається з «+380»',
    price: 'Формат ціни 0.00',
    privacy_policy_required_custom: "Це поле є обов'язковим",
    privacy_policy_website_custom: 'Перевірте формат посилання',
    required: "Це поле є обов'язковим",
    requiredIfFieldsEmpty: 'Заповніть одне з цих полів: {{fields}}',
    requiredIfFieldsNotEmpty: "Це поле є обов'язковим",
    specialChar: 'Спецсимвол',
  },
  termsAndConditions: {
    text01:
      "Ця Угода користувача (далі — Угода) регламентує відносини між Товариством з обмеженою відповідальністю «Олчетс» (код ЄДРПОУ 43351200) — Адміністрацією Веб-порталу «SKIBBLE» (далі — Адміністрація) і будь-якою особою (фізичною особою, юридичною особою, фізичною особою – підприємцем, або їх співробітниками), яка зареєструвалася на Веб-порталі «SKIBBLE» (далі — Користувач). \nЗареєструвавшись на Веб-порталі «SKIBBLE» та/або використовуючи його ресурси, Користувач підтверджує, що прочитав і висловив повну згоду (акцептував) з умовами цієї Угоди без якої-небудь зміни або доповнення. Якщо Користувач не згоден з умовами цієї Угоди, то для припинення дії Угоди щодо нього, Користувач повинен припинити подальшу реєстрацію на Веб-порталі «SKIBBLE» або відправити запит на видалення свого облікового запису (якщо Користувач раніше реєструвався на Веб-порталі «SKIBBLE» ) та перестати користуватися Веб-порталом «SKIBBLE», в тому числі шляхом відвідування Веб-порталу «SKIBBLE». \n1. Поняття: \n1.1. Веб-портал «SKIBBLE» (далі — Сервіс) — вебсайт, організований як системне багаторівневе об'єднання ресурсів та сервісів, призначених для обробки текстових повідомлень та файлів. Сервіс є об'єктом права інтелектуальної власності. Сервіс розміщений в мережі Інтернет за унікальним адресою (URL): ",
    text02:
      "1.2. Користування Веб-порталом — надання права на користування Сервісом будь-яким способом і в будь-якій формі в межах його оголошених функціональних можливостей, включаючи перегляд розміщених на сервісі матеріалів і реєстрацію на Веб-порталі «SKIBBLE». \n1.3. Реєстрація на Веб-порталі «SKIBBLE» — це підключення Користувача до Сервісу шляхом надання Адміністрацією Користувачу пароля та логіна до Сервісу. \n2. Ця Угода регулює відносини тільки з надання Адміністрацією Користувачу права на користування безкоштовним функціоналом Сервісу (далі — доступ до Сервісу). Для отримання права на користування платним функціоналом Сервісу Користувач повинен прийняти умови Договору-оферти. \n3. Адміністрація надає Користувачу право на користування безкоштовним функціоналом Сервісу, а Користувач зобов'язується дотримуватися всіх умов цієї Угоди. \n4. Користувачеві надається доступ до Сервісу тільки після проходження обов'язкової процедури реєстрації на Сервісі. \n5. Користувач зобов’язується: \n5.1. Стежити на сервісі за інформаційними повідомленнями про можливість користування безкоштовним функціоналом Сервісу, випуск нових версій Сервісу або про внесення змін до чинного Сервісу. \n5.2. Самостійно стежити за змінами в даній Угоді. \n5.3. Надавати точну, актуальну та повну інформацію, яка необхідна для користування Сервісом. \n5.4. Запобігати розкриття паролів та логінів, що використовуються для доступу до Сервісу. \n5.5. У разі розкриття або підозри на розкриття паролів та логінів, що використовуються для доступу до Сервісу, негайно письмово повідомити про це Адміністрацію. \n5.6. Не використовувати можливості Сервісу у цілях, які можуть бути кваліфіковані як порушення законодавства України. \n5.7. Виконувати інші зобов'язання, передбачені цією Угодою. \n6. Користувач має право: \n6.1. Отримати доступ до Сервісу після підтвердження реєстрації, шляхом відкриття підтверджуючого посилання. \n6.2. Отримувати від Адміністрації консультації, пов'язані із здійсненням доступу до Сервісу та його функціонуванням. \n6.3. Здійснювати інші права, передбачені цією Угодою, Угодою про конфіденційність та захист персональних даних, Угодою про участь в Партнерській програмі. \n7. Користувачеві забороняється вчиняти дії, спрямовані на: \n7.1. Передачу третім особам паролів та логінів, що використовуються для доступу до Сервісу. \n7.2. Спроби несанкціонованого доступу до комп'ютерної системи, на якій базується Сервіс. \n7.3. Пересилання та/або завантаження на Сервіс файлів, які можуть пошкодити комп'ютерні програми інших користувачів або Адміністрації. \n7.4. Розміщення в межах Сервісу інформації, яка може розглядатися як образлива, а також розміщення на Сервісі матеріалів або будь-яких даних, які порушують чинне законодавство України (включаючи матеріали та/або дані, що охороняються законодавством України про авторське право, або інформацію, що являється комерційною таємницею). \n7.5. Використання при роботі з Сервісом автоматизованих агентів, роботів або автоматизованого програмного забезпечення, відмінного від пошукових програм та браузерів. \n7.6. Здійснення зворотної розробки (reverse engineering), декомпіляцію, а також використання спеціальних технологій, необхідних для системи подачі звітів в електронному вигляді та електронного підпису файлів, поза Сервісом. \n8. Адміністрація має право: \n8.1. Надати Користувачу пароль та логін для забезпечення доступу до Сервісу після проходження ним повної процедури реєстрації на Сервісі. \n8.2. Надавати Користувачу консультації, пов'язані із здійсненням доступу до Сервісу та його функціонуванням. \n8.3. Повідомляти Користувача про можливість користування безкоштовним функціоналом Сервіса, випуск нових версій Сервісу, а також про будь-які істотні зміни в Сервісі. \n8.4. В односторонньому порядку зупиняти доступ Користувача до Сервісу в разі порушення Користувачем пп. 7.1.— 7.6. цієї Угоди. \n8.5. На зміну положень Угоди без попереднього повідомлення Користувача. \n8.6. Здійснювати інші права, передбачені цією Угодою. \n9. Адміністрація зобов'язана знищити всі без винятку персональні дані Користувача при отриманні відповідного запиту від Користувача. \n10. Беручи умови Угоди, Користувач дає згоду на отримання інформаційних розсилок на вказану при реєстрації електронну адресу. \n11. Адміністрація докладає всіх можливих зусиль для забезпечення нормальної працездатності Сервісу. \n12. Адміністрація залишає за собою право призупиняти роботу Сервісу для проведення профілактичних робіт. \n13. Угода про конфіденційність та захист персональних даних: \n13.1. Порядок збору, використання та розголошення інформації, яка може бути визнана конфіденційною, здійснюється на підставі Угоди про конфіденційність та захист персональних даних. \n13.2 Порядок обробки (збирання, накопичення, зберігання, уточнення, використання, передача, блокування, знищення) персональних даних Користувача здійснюється на підставі Угоди про конфіденційність та захист персональних даних. \n13.3. Приймаючи умови цієї Угоди або відвідуючи Сервіс, Користувач автоматично погоджується з умовами Угоди про конфіденційність та захист персональних даних — в частині використання персоніфікованої та не персоніфікованої конфіденційної інформації відповідно. \n14. Адміністрація має право в односторонньому порядку внести зміни в умови надання доступу до Сервісу, розмістивши про це інформацію в межах Сервісу в публічному доступі та внісши зміни до цієї Угоди. \n15. Для належного надання доступу до Сервісу Користувачеві, Адміністрація отримує право на використання, зберігання, обробку та поширення персональних даних Користувача в рамках Закону України «Про захист персональних даних». \n16. У разі виникнення між Адміністрацією та Користувачем суперечок або розбіжностей, що випливають з цієї Угоди або пов'язаних з нею, Сторони вживатимуть всіх заходів до вирішення їх шляхом переговорів між собою. \n17. Всі послуги надаються в електронному вигляді за передоплатою, згідно з обраним тарифним планом. Перелік доступних тарифних планів відображений за унікальною адресою - ",
    link: 'https://www.skibble.chat/ ',
    widgetLink: 'https://app.skibble.chat ',
    text1:
      'Розрахунок відбувається виключно у гривні. Сума, що підлягає сплаті в гривнях, визначається за офіційним курсом відповідної валюти на день платежу та відображається в момент здійснення платежу. \n18. Повернення грошових коштів і скасування транзакції за надання інформаційних послуг - НЕ НАДАЄТЬСЯ.',
    header1: '19. ВІДМОВА ВІД ГАРАНТІЙ. КОРИСТУВАЧ ПОВНІСТЮ УСВІДОМЛЮЄ ТА ПІДТВЕРДЖУЄ, ЩО:',
    text2:
      "A) ВИКОРИСТОВУЄ БЕЗКОШТОВНИЙ ФУНКЦІОНАЛ СЕРВІСУ ПОВНІСТЮ НА ВЛАСНИЙ РИЗИК. ПОСЛУГИ НАДАЮТЬСЯ «ЯК Є» ТА «ТЕ, ЩО Є». АДМІНІСТРАЦІЯ ОСОБЛИВО ПІДКРЕСЛЮЄ ВІДСУТНІСТЬ БУДЬ-ЯКИХ ГАРАНТІЙ, ЯК ЯВНИХ, ТАК І ЩО ЯВНИХ, У ТОМУ ЧИСЛІ, НЕ ОБМЕЖУЮЧИСЬ, ГАРАНТІЇ ЯКОСТІ ПОСЛУГ, ПРИДАТНОСТІ ЇХ ДЛЯ ТІЄЇ ЧИ ІНШОЇ МЕТИ І ВІДСУТНОСТІ. \nБ) АДМІНІСТРАЦІЯ НЕ ГАРАНТУЄ, ЩО (1) ПОСЛУГИ БУДУТЬ ВІДПОВІДАТИ ВИМОГАМ КОРИСТУВАЧА (2) ПОСЛУГИ БУДУТЬ ПОСТАВЛЯТИСЯ БЕЗПЕРЕБІЙНО, ВЧАСНО, БЕЗПОМИЛКОВО ТА БЕЗПЕЧНО, (3) РЕЗУЛЬТАТИ, ОТРИМАНІ В РЕЗУЛЬТАТІ ВИКОРИСТАННЯ ПОСЛУГ, БУДУТЬ ДОСТОВІРНИМИ ЧИ НАДІЙНИМИ, (4) ЯКІСТЬ БУДЬ-ЯКИХ ПОСЛУГ, ІНФОРМАЦІЇ ТА ІНШИХ МАТЕРІАЛІВ, ОТРИМАНИХ КОРИСТУВАЧЕМ ЗА ДОПОМОГОЮ СЕРВІСУ, БУДЕ ВІДПОВІДАТИ ВАШИМ ОЧІКУВАННЯ ТА (5) БУДЬ-ЯКІ ПОМИЛКИ В ПРОГРАМНОМУ ЗАБЕЗПЕЧЕННІ БУДУТЬ ВИПРАВЛЯТИСЯ. \nВ) ЗАВАНТАЖЕННЯ ТА ОТРИМАННЯ ІНШИМ СПОСОБОМ БУДЬ-ЯКОГО МАТЕРІАЛУ ЗА ЧАС ПРОВЕДЕННЯ ВИКОРИСТАННЯ ПОСЛУГ ЗДІЙСНЮЄТЬСЯ НА ВЛАСНИЙ РИЗИК КОРИСТУВАЧА, ЯКИЙ НЕСЕ ПОВНУ ВІДПОВІДАЛЬНІСТЬ ЗА БУДЬ-ЯКЕ ПОШКОДЖЕННЯ ЙОГО КОМП'ЮТЕРА, ВТРАТУ ДАНИХ ТА ІНШІ НАСЛІДКИ.\nГ) НІЯКІ РЕКОМЕНДАЦІЇ АБО ДАНІ, ОТРИМАНІ КОРИСТУВАЧЕМ УСНО АБО ПИСЬМОВО ВІД АДМІНІСТРАЦІЇ АБО ЗА ДОПОМОГОЮ ПОСЛУГ, НЕ НАКЛАДАЮТЬ НА АДМІНІСТРАЦІЮ ГАРАНТІЇ, ВІДМІННІ ВІД ТИХ, ЩО ВРАХОВАНІ ЦІЄЮ УГОДОЮ.",
    header2:
      '20. ОБМЕЖЕННЯ ВІДПОВІДАЛЬНОСТІ. КОРИСТУВАЧ ПОВНОЮ МІРОЮ УСВІДОМЛЮЄ ТА ПІДТВЕРДЖУЄ, ЩО АДМІНІСТРАЦІЯ НЕ БУДЕ НЕСТИ ВІДПОВІДАЛЬНІСТЬ',
    text3:
      'ЗА БУДЬ-ЯКІ ПРЯМІ, НЕПРЯМІ, ВИПАДКОВІ, СПЕЦІАЛЬНІ, НАКЛАДЕНІ ЯК ПОКАРАННЯ ЗБИТКИ, У ТОМУ ЧИСЛІ, НЕ ОБМЕЖУЮЧИСЬ, ВТРАТОЮ ПРИБУТКУ, ЗБИТКИ ВІД ВИКОРИСТАННЯ, ВТРАТУ ДАНИХ АБО БУДЬ-ЯКІ ІНШІ НЕМАТЕРІАЛЬНІ ВТРАТИ, ЗБИТКИ ПРЕСТИЖУ ТА ІНШІ ЗБИТКИ (НАВІТЬ ЯКЩО АДМІНІСТРАЦІЯ БУЛА ПРОІНФОРМОВАНІ ПРО МОЖЛИВІСТЬ ТАКОГО ЗБИТКУ),ЩО ВИНИКАЄ ВНАСЛІДОК: \nА) ВИКОРИСТАННЯ АБО НЕМОЖЛИВОСТІ ВИКОРИСТАННЯ ФУНКЦІОНАЛУ СЕРВІСУ. \nБ) ЗМІНИ УМОВ УГОДИ, ОТРИМАННЯ ДАНИХ ВЗАМІН НАБУТИХ ЧЕРЕЗ АБО ЗА ДОПОМОГОЮ ПОСЛУГ АБО В РЕЗУЛЬТАТІ УКЛАДЕННЯ УГОД, ПОВІДОМЛЕНЬ ТА ІНФОРМАЦІЇ, ОТРИМАНОЮ ВІД АБО ЗА ДОПОМОГОЮ ПОСЛУГ. \nВ) НЕ УПОВНОВАЖЕНОГО ДОСТУПУ ДО ДАНИХ КОРИСТУВАЧА АБО ЗМІНИ ПЕРЕДАВАЄМИХ НИМ АБО ДАНИХ, ЩО ЗБЕРІГАЮТЬСЯ НА СЕРВЕРІ. \nГ) ЗАЯВ АБО ПОВЕДІНКИ БУДЬ-ЯКОЇ ОСОБИ НА СЕРВІСІ. \nД) БУДЬ-ЯКОГО ІНШОГО ВИПАДКУ, ЩО МАЄ ВІДНОШЕННЯ ДО СЕРВІСУ.',
  },
  privacyPolicy: {
    text: 'Ця Угода про конфіденційність та захист персональних даних (далі — Угода) регулює відносини з обробки (збір, накопичення, зберігання, уточнення, використання, передання, блокування, знищення) Товариством з обмеженою відповідальністю «Олчетс» (код ЄДРПОУ 43351200) — Адміністрацією Інформаційного сервісу «SKIBBLE» (далі — Адміністрація), персональних даних будь-якої юридичної особи, або фізичної особи – підприємця, або їх співробітників, які зареєструвалися на сайті Інформаційного сервісу «SKIBBLE» (далі — Користувач).\nЗареєструвавшись на сайті Інформаційного сервісу «SKIBBLE» (далі — Сайт) та надавши свої персональні дані, Користувач підтверджує, що прочитав та висловив цілковиту згоду з умовами Угоди без будь-якої зміни чи доповнення, а також дозволив Адміністрації обробку своїх персональних даних.',
    header1: '1. ДЖЕРЕЛА ІНФОРМАЦІЇ',
    text1:
      '1.1. Адміністрації доступна інформація, яку вона отримує такими способами:\n– інформація, яку Користувачі надають:\nа) при реєстрації Користувача на Сайті,\nб) в рамках заходів, які проводить Адміністрація (опитування, заяви, форми зворотного зв’язку),\nв) шляхом внесення записів Користувачем у реєстраційні онлайн-форми під час користування послугами, наданими на Сайті;\n– під час листування Адміністрації з Користувачами електронною поштою;\n– технічна інформація — дані про інтернет-провайдера Користувача, IP-адресу, характеристики ПК та програмного забезпечення, якими він користується, дані про завантажені та вивантажені на Сайт файли і т. п.;\n– статистичні дані про переваги окремо взятого Користувача (тематика переглянутих сторінок).\n1.2. Конфіденційною в розумінні цієї Угоди може бути визнана лише інформація, яка зберігається в базі даних Сайту в зашифрованому вигляді та доступна для перегляду виключно Адміністрації.\n1.3. Інформація про особу, яку вона добровільно розмістила у загальних розділах Сайту під час заповнення реєстраційних онлайн-форм та яка є доступною для будь-якого Користувача Сайту, або інформація, яку можна вільно отримати з інших загальнодоступних джерел, не є конфіденційною.',
    header2: '2. БЕЗПЕКА',
    text2:
      '2.1. Адміністрація використовує сучасні технології для забезпечення конфіденційності персональних даних, а також даних, які залишають Користувачі при заповненні реєстраційних онлайн-форм, з метою забезпечення максимального захисту інформації.\n2.2. Доступ до особистої інформації Користувача здійснюється через систему авторизації з логіном та паролем. Користувач зобов’язується самостійно забезпечити збереження авторизаційних даних, ні під яким приводом не розголошувати їх третім особам. Будь-які зміни особистої інформації, внесені через авторизаційні дані, будуть вважатися такими, які Користувач здійснив особисто.',
    header3: '3. ВИКОРИСТАННЯ ІНФОРМАЦІЇ',
    text3:
      '3.1. Адміністрація здійснює обробку тільки тієї інформації, яку Користувач надає добровільно.\n3.2. Адміністрація має право на обробку персональної інформації про Користувача, отриманої згідно з п. 1.1.3.3. Персональною інформацією Користувача, отриманою згідно з п. 1.1., є:\n– електронна адреса, ідентифікаційний код, контактна інформація;\n– IP-адреса Користувача;\n– інформація, яку можна отримати з файлів cookies;\n– будь-яка інша інформація, яку Користувач залишив про себе при заповненні реєстраційних онлайн-форм на Сайті.\n3.4. Адміністрація оброблює персональну інформацію Користувача для:\n– надання послуг Інформаційного сервісу «SKIBBLE»;\n– оцінки зацікавлення Користувачів у наших послугах та інформування їх про нові послуги та оновлення Сайту;\n– вирішення спорів та суперечливих ситуацій;\n– іншого, про що Адміністрація сповіщає Користувача, запитуючи приватну інформацію.\n3.5. Адміністрація може використовувати персональні дані Користувача з метою розсилання повідомлень технічного та адміністративного характеру, новин.\n3.6. Адміністрація використовує технології відстеження (файли cookies) для збирання таких персональних даних, як тип браузера або операційна система, сторінка-посилання, шлях на Сайті, домен інтернет-провайдера і т. п., з метою отримання загальної інформації про те, як Користувачі користуються Сайтом. Файли cookies дозволяють удосконалювати цей Сайт відповідно до вимог його Користувачів.\n3.7. Адміністрація зберігає всю інформацію, зібрану з використанням файлів cookies, у форматі, який не передбачає можливості ідентифікувати особу. Інформація, яку отримують через файли cookies, не може бути відкрита третім особам. Ця інформація не буде несанкціоновано передаватися третім особам.\n3.8. Інформація, зібрана про Користувача, не підлягає розголошенню третім особам, окрім випадків, передбачених законодавством України.',
    header4: '4. ЗАКЛЮЧНІ ПОЛОЖЕННЯ',
    text4:
      '\n4.1. Заповнюючи форму реєстрації на Сайті або відвідуючи сторінки Сайту, Користувач автоматично приймає умови Угоди.\n4.2. При обробці Адміністрацією персональних даних Користувача він має такі самі права, що й суб’єкт персональних даних, права якого передбачені в ',
    link: 'ст. 8 ЗУ «Про захист персональних даних».',
    text5:
      '4.3. Діяльність Адміністрації здійснюється відповідно до законодавства України. Будь-які претензії, спори,\n4.4. Умови цієї Угоди Адміністрація може змінювати в односторонньому порядку, і вони набирають чинності протягом семи календарних днів з моменту їх публікації на Сайті. Якщо зміни будуть суттєвими, Адміністрація проінформує Користувача електронною поштою (надсилається на адресу електронної пошти, зазначену при реєстрації) або шляхом повідомлення на цьому Сайті до набрання чинності змінами.',
  },
}
